import React, { useContext } from 'react';
import Icon from '../common/Icon';
import { OptionsContext } from '../../hooks/Contexts';
import { adjustSortablesAfterDelete } from '../../helpers/sorters';
import {
  handleDeleteOption,
  handleUpdateOption,
} from './constants/handleOption';

const OptionControls = ({ editing, field, option, toggleEdit }) => {
  const { id } = option;
  const { setOptions, determineSort, openCalModal, displayLocalQuotas } =
    useContext(OptionsContext);

  const handleUpdatesFromIcons = async (e, property, value) => {
    e.preventDefault();
    let updatingOption = { [property]: value };
    let updated = await handleUpdateOption(id, updatingOption);
    if (updated.ok) {
      setOptions((opts) => {
        let updated = opts.find((o) => o.id == id);
        updated[property] = value;
        let untouched = opts.filter((o) => o.id != id);
        if (property == 'default' && field.type != 'checkbox') {
          untouched = untouched.map((o) => ({ ...o, default: false }));
        }
        return determineSort([...untouched, updated]);
      });
    }
  };

  const handleDelete = async (e, id) => {
    e.preventDefault();
    await handleDeleteOption(id, (response) => {
      if (response.ok) {
        setOptions((opts) => {
          let adjusted = adjustSortablesAfterDelete(opts, id);
          return determineSort(adjusted);
        });
      }
    });
  };

  const handleCalendarClick = (e) => {
    e.preventDefault();
    openCalModal(option);
  };

  return (
    <div className='controls flex-controls'>
      {!editing && (
        <span className='option-id'>
          <strong>ID:</strong>
          {option.id}
        </span>
      )}
      {field.informs_global ? (
        <>
          {option.response_options_count} of {option.local_quota || '0'}
          <Icon
            className='edit disabled'
            title={option.hidden ? 'Unhide' : 'Hide'}
            icon={option.hidden ? 'eye-slash' : 'eye'}
            faPrefix={'regular'}
            disabled={true}
          />
        </>
      ) : (
        <>
          {displayLocalQuotas &&
            `${option.response_options_count} of ${option.local_quota || '0'} (Admin)`}
          <Icon
            className='edit'
            title={option.hidden ? 'Unhide' : 'Hide'}
            icon={option.hidden ? 'eye-slash' : 'eye'}
            faPrefix={'regular'}
            onClick={(e) => handleUpdatesFromIcons(e, 'hidden', !option.hidden)}
          />
        </>
      )}
      {field.type != 'checkbox' && (
        <Icon
          className='edit'
          title={option.calendar_event ? 'Manage ical' : 'Add ical'}
          icon={option.calendar_event ? 'calendar-check' : 'calendar-plus'}
          onClick={(e) => handleCalendarClick(e)}
          faPrefix={'regular'}
        />
      )}
      <Icon
        className='edit'
        title='Mark as default'
        icon={option.default ? 'toggle-on' : 'toggle-off'}
        onClick={(e) => handleUpdatesFromIcons(e, 'default', !option.default)}
      />

      {editing ? (
        <>
          <button type='submit'>
            Save <Icon icon='save' />
          </button>
          <button
            className='blue'
            onClick={(e) => {
              e.preventDefault();
              toggleEdit();
            }}
          >
            Cancel <Icon icon='xmark' />
          </button>
        </>
      ) : (
        <Icon className='edit' onClick={toggleEdit} icon='pencil' />
      )}

      {!option.response_options_count && (
        <Icon icon='trash' onClick={(e) => handleDelete(e, id)} />
      )}
    </div>
  );
};

export default OptionControls;
